<template>
  <a-modal
    :visible="visible"
    :title="options.title"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :width="1200"
    @cancel="cancelHandel">
    <a-row>
      <a-col :xs="24" :md="24" :style="{ height: '600px' }">
        <vue-cropper
          ref="cropper"
          :img="options.img"
          :info="true"
          :autoCrop="options.autoCrop"
          :autoCropWidth="options.autoCropWidth"
          :autoCropHeight="options.autoCropHeight"
          :fixedBox="options.fixedBox"
          :mode="cropperMode"
          @realTime="realTime">
        </vue-cropper>
      </a-col>
    </a-row>
    <template slot="footer">
      <a-button key="back" @click="cancelHandel">取消</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="confirmLoading"
        @click="okHandle">保存
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import OssClient from '@/utils/OssClient';
import S3Client from '@/utils/S3Client';
function getLast3Str(fileName) {
  const index = fileName.lastIndexOf('.') + 1;
  return fileName.substring(index);
}
function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
function random_string(len) {
  // len = len || 32;
  const length = len || 32;
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678';
  const maxPos = chars.length;
  let pwd = '';
  for (let i = 0; i < length; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}
// base 64 转成二进制文件流
export default {
  props: {
    imgType: {
      type: String,
      default: '',
    },
    fileName: {
      type: String, // 文件名
      default: '',
    },
    // 图片渲染方式
    cropperMode: {
      type: String,
      default: 'contain'
    }
  },
  data() {
    return {
      visible: false,
      img: null,
      confirmLoading: false,
      options: {
        img: '', // 裁剪图片的地址
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 180, // 默认生成截图框宽度
        autoCropHeight: 180, // 默认生成截图框高度
        fixedBox: true, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是原圆形
        serviceType: '',
        title: '修改图片',
      },
      previews: {},
      url: {
        upload: '/sys/common/saveToImgByStr',
      },
    };
  },
  methods: {
    edit(record) {
      const { options } = this;
      console.log(record);
      this.visible = true;
      this.options = Object.assign({}, options, record);
      if (getLast3Str(this.fileName) === 'gif') {
        this.uploadPic();
      }
    },
    // 取消截图
    cancelHandel() {
      this.confirmLoading = false;
      this.visible = false;
      this.$emit('cropper-no');
    },
    // 确认截图
    async okHandle() {
      const that = this;
      that.confirmLoading = true;
      // 获取截图的base64 数据
      this.$refs.cropper.getCropData(async (data) => {
        var file = dataURLtoFile(data, this.fileName);
        var formData = new window.FormData();
        console.log(this.options.serviceType)
        console.log('file:' + this.fileName);
        formData.append('uploadFile', file);
        const randomName = `${random_string(6)}_${new Date().getTime()}.${this.fileName.split('.').pop()}`;
        if (this.options.serviceType === 'S3') {
          console.log('using S3 service')
          const client = S3Client();
          try {
            await client.upload({
              Bucket: 'lama-hourani',
              Key: randomName,
              Body: file,
              ContentType: file.type,
              ACL: 'public-read',
              'Access-Control-Allow-Origin': '*',
            }, (err, data) => {
              if (err) {
                console.log(err);
                // 上传失败
              } else if (data) {
                this.currentImgPath = 'https://lama-hourani.s3.us-east-2.amazonaws.com/' + randomName;
                console.log(this.currentImgPath)
                this.$emit('cropper-ok', this.currentImgPath);
                this.visible = false;
                that.confirmLoading = false;
                this.$message.info('上传成功');
              }
            })
          } catch (error) {
            console.log(error)
            this.$message.error('上传失败');
          }
        } else if (this.options.serviceType === 'OSS') {
          // 上传OSS
          const client = OssClient();
          // 随机命名
          try {
            // 分片上传文件
            const result = await client.put(randomName, file);
            if (result) {
              const pre = result.url.split('//');
              this.currentImgPath = 'https://' + pre[1] + '?x-oss-process=image/format,webp';
              console.log('currentImgPath' + this.currentImgPath);
              this.$emit('cropper-ok', this.currentImgPath);
              this.visible = false;
              that.confirmLoading = false;
              this.$message.info('上传成功');
            }
          } catch (error) {
            this.$message.info('上传失败');
          }
        }
      });
    },
    // 移动框的事件
    realTime(data) {
      this.previews = data;
    },
    async uploadPic() {
      var data = this.options.img;
      var file = dataURLtoFile(data, this.fileName);
      var formData = new window.FormData();
      console.log(this.options.serviceType)
      console.log('file:' + this.fileName);
      formData.append('uploadFile', file);
      const randomName = `${random_string(6)}_${new Date().getTime()}.${this.fileName.split('.').pop()}`;
      if (this.options.serviceType === 'S3') {
        console.log('using S3 service')
        const client = S3Client();
        try {
          await client.upload({
            Bucket: 'lama-hourani',
            Key: randomName,
            Body: file,
            ContentType: file.type,
            ACL: 'public-read',
            'Access-Control-Allow-Origin': '*',
          }, (err, data) => {
            if (err) {
              console.log(err);
              // 上传失败
            } else if (data) {
              this.currentImgPath = 'https://lama-hourani.s3.us-east-2.amazonaws.com/' + randomName;
              console.log(this.currentImgPath)
              this.$emit('cropper-ok', this.currentImgPath);
              this.visible = false;
              // that.confirmLoading = false;
              this.$message.info('上传成功');
            }
          })
        } catch (error) {
          console.log(error)
          this.$message.error('上传失败');
        }
      } else if (this.options.serviceType === 'OSS') {
        // 上传OSS
        const client = OssClient();
        // 随机命名
        try {
          // 分片上传文件
          const result = await client.put(randomName, file);
          if (result) {
            const pre = result.url.split('//');
            this.currentImgPath = 'https://' + pre[1] + '?x-oss-process=image/format,webp';
            console.log('currentImgPath' + this.currentImgPath);
            this.$emit('cropper-ok', this.currentImgPath);
            this.visible = false;
            // that.confirmLoading = false;
            this.$message.info('上传成功');
          }
        } catch (error) {
          this.$message.info('上传失败');
        }
      }
    }
  },
};
</script>

<style lang="less" scoped>
.avatar-upload-preview_range,
.avatar-upload-preview {
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;
  overflow: hidden;

  img {
    background-color: red;
    height: 100%;
  }
}

.avatar-upload-preview_range {
  border-radius: 0;
}
</style>
